import { splitProps } from 'solid-js';
import style from '#src/client/common/layout/Collapser.module.css';

export default function Collapser(props) {
    const [local, others] = splitProps(props, [
        'isOpen',
        'class',
    ]);

    const classes = () => {
        return [
            local.class,
            style.outer,
            props.isOpen ? style.open : '',
        ].join(' ');
    };

    return (
        <div {...others} class={classes()}>
            <div class={style.inner}>
                {props.children}
            </div>
        </div>
    );
}
